import styles from './style.module.scss';

import React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'outline' | 'outline_light' | 'ghost' | 'dark';
};
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'default', ...props }, ref) => {
    return (
      <button
        className={`${styles.button} ${styles[variant]} ${className}`}
        ref={ref}
        {...props}
      />
    );
  },
);

export default Button;
